import { render, staticRenderFns } from "./loginBox.vue?vue&type=template&id=1947cbc9"
import script from "./loginBox.vue?vue&type=script&lang=js"
export * from "./loginBox.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/loginBox.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/login/loginBox.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports